import type { LandingStrings } from './en';

export const tr: LandingStrings = {
  header: {
    brandSubtitle: 'Büyülü dükkân',
    contact: 'İletişim',
    about: 'Oyun hakkında',
    language: 'Dil',
  },
  footer: {
    terms: 'Kullanım Koşulları',
    privacy: 'Gizlilik Politikası',
    copyright: '{year} {holder}. Tüm hakları saklıdır.',
  },
  home: {
    heroTitle: 'İksirler ve büyülü bir dükkân üzerine sıcacık bir 3D oyun.',
    heroDescription:
      'Büyülü karmaşanın arasında malzemeleri ara, kazanda iksirler hazırla ve onları kendi dükkânında sat.',
    features: [
      {
        title: 'Sana özel şişe',
        desc: 'Biçim, kapak ve iksirin rengi — güzel şişeler daha pahalıya satılır.',
      },
      {
        title: 'Anlamlı bir zanaat',
        desc: 'Her iksirin kendi tarifi var ve birçoğu oyunda gerçekten işe yarıyor.',
      },
      {
        title: 'Takip etmesi keyifli bir hikâye',
        desc: 'Büyükannen tatile gitti ve dükkânını sana bıraktı; Moren adında bir kurbağa da alacağını istiyor.',
      },
      {
        title: 'Gerçekten senin olan bir dükkân',
        desc: 'Yalnızca kendi ellerinle hazırladıkların satılır.',
      },
    ],
    appStore: 'App Store',
    googlePlay: 'Google Play',
    comingSoon: 'Yakında çıkıyor',
    tags: { search: 'Gölgesinden bul', craft: '3D kazanda iksir', shop: 'Sıcacık dükkân' },
  },
  about: {
    title: 'Qevryno hakkında',
    intro: [
      'Qevryno’ya hoş geldin: büyünün el emeğiyle yapıldığı sıcacık bir iksir oyunu.',
      'Büyükannen tatile gitti ve senden gizemli eski evine göz kulak olmanı istedi: unutulmuş tarifler, büyülü malzemeler ve nasıl kaynayacağını hâlâ hatırlayan bir kazan. Alt katta küçük bir dükkân var ve bütün köy, artık ona kimin baktığını merak ediyor.',
      'İksirler hazırla, pofuduk yardımcı kedine bak, eserlerini cana yakın müşterilere sat ve büyülü evini süslemek için altın kazan — kendi hızında, süre baskısı olmadan.',
    ],
    whatTitle: 'Bu nasıl bir oyun?',
    what: [
      'Qevryno, gizli nesne bulmayı, simya zanaatini ve küçük bir dükkân simülasyonunu bir araya getiren rahatlatıcı bir 3D bulmaca oyunu. Sıcacık (cozy) oyunları, casual bulmacaları, gizli nesne bulma oyunlarını, iksir yapma ve simya oyunlarını ya da kendi büyülü dükkânını işletmeyi seviyorsan, aradığın oyun bu.',
      'Tek oyunculu bir oyun ve internet olmadan çalışıyor; bağlantı yalnızca satın alımlar ve isteğe bağlı ödüllü videolar için gerekli. Banner ya da açılır reklam yok: bonus karşılığındaki kısa Google AdMob videosu yalnızca sen dokunduğunda oynatılır. İsteğe bağlı satın alımlar: mücevherler ve içeriği görünen malzeme paketleri. Yakında iOS ve Android’de; Türkçe, İngilizce, Rusça, İspanyolca, Almanca, Fransızca, Felemenkçe, İtalyanca, Portekizce (Brezilya), Lehçe, Japonca, Korece ve Geleneksel Çince dillerinde.',
    ],
    doTitle: 'Neler yapacaksın?',
    doList: [
      'Ormandaki büyülü 3D açıklıklarda gizli malzemeleri ara — her biri küçük bir diorama gibi.',
      'Kazanda büyülü tarifler hazırla: bir dengeleyici, bir ana malzeme, zaman otları ve bir damla renk.',
      'Kendi şişelerini tasarla — biçim, kapak, iksirin rengi; güzel olanlar daha pahalıya satılır.',
      'Kendi dükkânını işlet: müşteriler, itibar, panayırlar ve görevler.',
      'Hikâyeyi takip et: büyükannen tatile gitti ve dükkânını sana bıraktı; Moren adında bir kurbağa ise alacağını istemekten vazgeçmiyor.',
      'Bulduklarını havanda ez, kâsede karıştır ve sim ekle — her karışımın kendine özgü bir dokusu ve rengi var.',
      'Yardımcı kedini besle ve dükkânını süsle.',
    ],
    faqTitle: 'Sık sorulan sorular',
    faq: [
      { q: 'Qevryno ücretsiz mi?', a: 'Evet. Oyun ücretsiz ve hiç ödeme yapmadan oynanabilir. İsteğe bağlı satın alımlar: mücevherler ve malzeme paketleri.' },
      { q: 'İnternetsiz çalışıyor mu?', a: 'Evet. Oyunun kendisi bağlantıya ihtiyaç duymaz — uçakta ya da battaniyenin altında iksir hazırla. İnternet yalnızca satın alımlar ve isteğe bağlı ödüllü videolar için kullanılır.' },
      { q: 'Reklam var mı?', a: 'Yalnızca isteğe bağlı olanlar. Ekranlar arasında banner ya da açılır reklam yok. Birkaç yerde, istersen kısa bir video izleyip bonus alabilirsin — örneğin mana. Oyunda hiçbir şey seni bunları izlemeye zorlamaz. Videoları Google AdMob gösterir; ayrıntılar Gizlilik Politikası’nda.' },
      { q: 'Hangi platformlarda?', a: 'iOS ve Android’de; Türkçe, İngilizce, Rusça, İspanyolca, Almanca, Fransızca, Felemenkçe, İtalyanca, Portekizce (Brezilya), Lehçe, Japonca, Korece ve Geleneksel Çince dillerinde.' },
      { q: 'Korkutucu ya da stresli mi?', a: 'Hiç değil. Sakin ve sıcacık bir oyun: yumuşak müzik, hatalara ceza yok, bir de şapkalı bir kedi.' },
    ],
  },
  contact: {
    title: 'Bize ulaş',
    subtitle: 'Qevryno hakkında bir soru, bir hata, bir satın alma ya da reklam mı? Bize e-postayla yaz.',
    write: 'E-posta yaz',
    mailSubject: 'Qevryno: destek',
    tip: 'Hangi cihazı kullandığını ve ne olduğunu yaz; böylece sana yardım etmemiz kolaylaşır.',
    info: {
      title: 'İletişim bilgileri',
      email: 'E-posta',
      security: 'Güvenlik',
      legalName: 'Geliştirici',
      address: 'Adres',
    },
    refunds: {
      title: 'İadeler ve satın alımlar',
      description: 'Tüm satın alımlar Apple App Store veya Google Play üzerinden yapılır. Para iadesi için uygulama mağazasına başvur:',
      apple: 'Apple App Store',
      appleUrl: 'https://support.apple.com/tr-tr/HT204084',
      google: 'Google Play',
      googleUrl: 'https://support.google.com/googleplay/answer/2479637?hl=tr',
      link: 'İade iste',
      note: 'Ödemeleri kendimiz almıyoruz ve para iadesi yapamıyoruz. Bir satın alma oyuna gelmediyse «Ayarlar → Satın alımları geri yükle» bölümünü aç ya da bize yaz.',
    },
  },
  legal: {
    dataController: 'Veri sorumlusu',
    // Политика и условия есть на английском, русском и испанском; для остальных языков страница показывает английский текст и эту строку
    onlyIn: 'Bu belge yalnızca İngilizce, Rusça ve İspanyolca olarak mevcut; aşağıda İngilizce sürümü yer alıyor.',
  },
};
